<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel" attribute="name"/>
            </div>
            <div class="input-wrapper" v-if="source !== 'branch'">
              <input-widget :model="searchModel" attribute="level" type="select2" :items="levels"
                value-field="value" :label="false" :options="{placeholder: $t('Level')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="applies_to" type="select2" :items="appliesTo"
                value-field="value" :label="false" :options="{placeholder: $t('Applies To')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="calculate_from" type="select2" :items="calculateFrom"
                value-field="value" :label="false" :options="{placeholder: $t('Calculate From')}"
                display-field="${item.key}" multiple/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="lot_statuses" type="select2" :items="vendorChargeLotStatuses"
                value-field="value" :label="false" :options="{placeholder: $t('Lot Status')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_aggregate" type="select2" :items="yesNo"
                value-field="value" :label="false" :options="{placeholder: $t('Is Aggregate')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_taxable" type="select2" :items="yesNo"
                value-field="value" :label="false" :options="{placeholder: $t('Is Taxable')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_tax_inclusive" type="select2" :items="yesNo"
                value-field="value" :label="false" :options="{placeholder: $t('Is Tax Inclusive')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="is_active" type="select2" :items="yesNo"
                value-field="value" :label="false" :options="{placeholder: $t('Is Active')}"
                display-field="${item.key}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel"
                attribute="tax_rate_start" type="number" step="any" min="0" max="100"/>
            </div>
            <div class="input-wrapper">
              <input-widget :label="false" :placeholder="true" :model="searchModel"
                attribute="tax_rate_end" type="number" step="any" min="0" max="100"/>
            </div>
          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";

  const {mapState, mapActions} = createNamespacedHelpers('vendorCharges');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "VendorChargeSearch",
    components: {InputWidget},
    props: {
      branch: {
        type: Object,
        default: null
      }
    },
    computed: {
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        source: state => state.tableSource
      }),
      ...globalMapState(['appliesTo', 'calculateFrom', 'levels', 'yesNo', 'vendorChargeLotStatuses']),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.resetTable();
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>
